import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import React from 'react';
import PropTypes from 'prop-types';
var Option = function (_React$Component) {
  _inherits(Option, _React$Component);
  function Option() {
    _classCallCheck(this, Option);
    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }
  return Option;
}(React.Component);
Option.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Option.isSelectOption = true;
export default Option;